export const BonusSvg = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="24" height="24" rx="8" fill="white" />
		<rect width="24" height="24" rx="8" fill="url(#paint0_linear_24462_13030)" fillOpacity="0.32" />
		<path
			d="M5.73102 8.4357C5.94114 7.99418 6.48419 7.79984 6.94395 8.00162L13.2239 10.7577C13.6837 10.9595 13.8861 11.481 13.676 11.9225L11.028 17.4866C10.8179 17.9281 10.2748 18.1224 9.81505 17.9207L3.53506 15.1645C3.0753 14.9628 2.87292 14.4413 3.08304 13.9998L5.73102 8.4357Z"
			fill="url(#paint1_linear_24462_13030)"
		/>
		<path
			d="M10.6358 6.26585C10.9885 5.91801 11.5679 5.91053 11.9302 6.24914L16.6938 10.7023C17.056 11.0409 17.0638 11.5974 16.7112 11.9452L10.8494 17.7277C10.4968 18.0756 9.91736 18.0831 9.55514 17.7445L4.79149 13.2913C4.42927 12.9527 4.42148 12.3962 4.77409 12.0484L10.6358 6.26585Z"
			fill="url(#paint2_linear_24462_13030)"
		/>
		<path
			d="M16.5689 6.89878C17.0227 6.68481 17.5712 6.86459 17.794 7.30033L20.3602 12.3189C20.583 12.7547 20.3958 13.2813 19.942 13.4953L10.6039 17.8987C10.1502 18.1127 9.60169 17.9329 9.37888 17.4972L6.81266 12.4786C6.58985 12.0428 6.77707 11.5162 7.23081 11.3022L16.5689 6.89878Z"
			fill="url(#paint3_linear_24462_13030)"
		/>
		<path
			d="M13.9466 8.13672L16.6931 10.7042C17.0554 11.0428 17.0632 11.5993 16.7105 11.9471L10.8488 17.7297C10.7883 17.7893 10.7211 17.839 10.6495 17.8786L10.6039 17.9001C10.1502 18.1141 9.60169 17.9343 9.37888 17.4986L6.81266 12.48C6.58985 12.0442 6.77707 11.5175 7.23081 11.3036L13.9466 8.13672Z"
			fill="url(#paint4_linear_24462_13030)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_24462_13030"
				x1="7.3139e-07"
				y1="-6"
				x2="31.5729"
				y2="2.14155"
				gradientUnits="userSpaceOnUse">
				<stop stopColor="#C4FDA6" />
				<stop offset="0.203125" stopColor="#B3E27E" />
				<stop offset="0.794013" stopColor="#A8EAFF" />
				<stop offset="0.974692" stopColor="#4DCFFF" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_24462_13030"
				x1="9.23156"
				y1="17.5282"
				x2="6.45199"
				y2="8.21812"
				gradientUnits="userSpaceOnUse">
				<stop stopColor="#FFD540" />
				<stop offset="1" stopColor="#FFA800" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_24462_13030"
				x1="11.0291"
				y1="6.12797"
				x2="11.3229"
				y2="17.7688"
				gradientUnits="userSpaceOnUse">
				<stop offset="0.0001" stopColor="#C0E671" />
				<stop offset="1" stopColor="#5CA500" />
			</linearGradient>
			<linearGradient
				id="paint3_linear_24462_13030"
				x1="17.1186"
				y1="7.67242"
				x2="15.9331"
				y2="17.9831"
				gradientUnits="userSpaceOnUse">
				<stop stopColor="#75CFF4" />
				<stop offset="1" stopColor="#0094C2" />
			</linearGradient>
			<linearGradient
				id="paint4_linear_24462_13030"
				x1="15.9025"
				y1="8.76688"
				x2="12.1155"
				y2="18.1003"
				gradientUnits="userSpaceOnUse">
				<stop stopColor="#289DC6" stopOpacity="0.29" />
				<stop offset="1" stopColor="#289DC6" stopOpacity="0" />
			</linearGradient>
		</defs>
	</svg>
)
